import { render, staticRenderFns } from "./StopzettingOpvolging.vue?vue&type=template&id=1c304948&scoped=true"
import script from "./StopzettingOpvolging.vue?vue&type=script&lang=js"
export * from "./StopzettingOpvolging.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c304948",
  null
  
)

export default component.exports